<template>
  <v-toolbar
    app
    flat
    :class="['fixedPosition', 'pa-0', , isLoggedAsOther ? 'redBox' :'classicBox']"
    :style="{backgroundColor:toolbarColor}"
  >
    <v-flex layout row align-center class="justify-space-between" no-gutters>
      <v-flex layout row align-center justify-start>
        <v-img
          @click="newPath"
          class="logoImage pointerClass"
          src="/images/logo_text_white.png"
        />
      </v-flex>

      <v-flex layout align-center justify-center>
        <v-menu :close-on-content-click="true" :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <v-flex
                layout
                align-center
                justify-center
                class="pointerClass menuTextClass"
              >
                <v-toolbar-title
                  class="white--text font-weight-light menuTitleClass"
                  v-if="pathMenuTitle"
                >
                  {{ $tc('toolBar.path', pathMenuTitle) }}
                </v-toolbar-title>
                <v-toolbar-title
                  class="white--text font-weight-light menuTitleClass"
                  v-if="!pathMenuTitle"
                >
                  {{ $t('toolBar.paths') }}
                </v-toolbar-title>
                <v-icon large color="white"> mdi-chevron-down </v-icon>
              </v-flex>
            </div>
          </template>
          <v-list>
            <v-list-tile
              v-for="path in pathMenu"
              :key="path.pathId"
              @click="selectedPath(path.pathId)"
              align="center"
              justify="center"
            >
              <v-flex>
                {{ path.pathName }}
              </v-flex>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <v-toolbar-items v-if="isAdmin === true">
        <v-flex align-center layout>
          <v-menu
            :close-on-click="closeOnClick"
            bottom
            full-width
            nudge-bottom="30"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                clearable
                color="white"
                v-model="search"
                class="white--text"
                :label="loginLabel"
                v-on="on"
              >
              </v-text-field>
            </template>

            <v-list dense>
              <v-list-tile
                v-for="user in displayedUsers"
                :key="user._id"
                @click="selectUser(user._id)"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-text="user._id"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-toolbar-items>

      <v-flex layout row align-center justify-end>
        <v-flex
          layout
          align-center
          justify-end
          row
          pr-4
          class="pointerClass"
        >
          <v-card elevation="0" :style="{backgroundColor:toolbarColor}" href="https://support.explorama.app" target="_blank">
            <v-card-text class="white--text supportLink">
              {{ $t('toolBar.help') }}
            </v-card-text>
          </v-card>
        </v-flex>

        <v-menu
          :close-on-content-click="true"
          :offset-y="true"
          absolute
          :position-y="63"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-flex
              layout
              align-center
              justify-end
              class="pointerClass"
              v-on="on"
              v-bind="attrs"
            >
              <v-avatar v-if="imageSite" size="35">
                <img :src="imageSite" />
              </v-avatar>
              <v-avatar v-else color="white" size="30" class="pointerClass">
                <v-icon madium color="primary">mdi-home-outline</v-icon>
              </v-avatar>
              <v-card-text class="userText">
                {{ userNameToShow }}
              </v-card-text>
            </v-flex>
          </template>
          <v-list>
            <v-list-tile
              v-for="element in menuUser"
              :key="element.title"
              @click="selectUserMenu(element.to)"
              align="center"
              justify="center"
            >
              <v-flex>
                {{ element.title }}
              </v-flex>
            </v-list-tile>
            <v-list-tile align="center" justify="center">
              <v-flex>
                <v-btn
                  class="btn-flag"
                  v-for="entry in languages"
                  icon
                  :disabled="locale === entry.language"
                  :key="entry.title"
                  @click="changeLocale(entry)"
                >
                  <gb-flag :code="entry.flag" :size="entry.size" />
                </v-btn>
              </v-flex>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex
        layout
        align-center
        justify-center
        v-if="loadingSavedModifications"
        class="savedClass"
      >
        <v-icon medium color="green lighten-2" class="mdi-spin">
          mdi-loading
        </v-icon>
        <v-card-text class="savedText">
          {{ $t('toolBar.saving') }}
        </v-card-text>
      </v-flex>
      <v-flex
        layout
        align-center
        justify-center
        v-if="showSavedModifications"
        class="savedClass"
      >
        <v-icon medium color="green lighten-2">
          mdi-checkbox-marked-circle-outline
        </v-icon>
        <v-card-text class="savedText">
          {{ $t('toolBar.saved') }}
        </v-card-text>
      </v-flex>
      <v-flex
        layout
        align-center
        justify-center
        v-if="isError"
        class="savedClass"
      >
        <v-icon medium color="red"> mdi-alert-circle-outline </v-icon>
        <v-card-text class="errorText">
          {{ $t('toolBar.error') }}
        </v-card-text>
      </v-flex>
    </v-flex>
  </v-toolbar>
</template>

<script>
import * as JsSearch from 'js-search';
//    style="background-image: linear-gradient(to right, #009999, 40%, #006666);"
export default {
  data() {
    return {
      links: {},
      loadingSavedModifications: false,
      showSavedModifications: false,
      isLoggedAsOther: false,
      search: '',
      selected: '',
      users: [],
      closeOnClick: true,
      languages: [
        { flag: 'fr', language: 'fr', title: 'Français', size: 'small' },
        { flag: 'gb', language: 'en', title: 'English', size: 'small' },
      ],
      menuUser: [
        { title: this.$t('toolBar.profile'), to: 'profile' },
        //{title: this.$t('sidebar.credits'), to: 'credits'},
        { title: this.$t('toolBar.disconnect'), to: 'disconnect' },
      ],
    };
  },
  watch: {
    isLoading(newValue) {
      if (this.isLoading && !this.isError) this.isShowSavedModifications();
      return newValue;
    },
  },
  created() {
    this.langIconChangeSize('medium', 'small');
  },
  computed: {
    isLoading() {
      return this.$store.getters['app/isLoading'];
    },
    isError() {
      //console.log('is Error', this.$store.getters['app/isError'])
      return this.$store.getters['app/isError'];
    },
    userInfos() {
      return this.$store.getters['auth/currentUserInfos'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    accountInfos() {
      return this.$store.getters['accounts/currentAccount'];
    },
    currentAccountId() {
      return this.$store.state['accounts/currentAccountId'];
    },
    userNameToShow() {
      if (this.accountInfos && this.accountInfos.name.fr) {
        return this.accountInfos.name.fr;
      } else if (this.userInfos && this.userInfos.firstname) {
        return this.userInfos.firstname;
      }
      return '';
    },
    imageSite() {
      if (this.accountInfos && this.accountInfos.logoUrl) {
        return this.accountInfos.logoUrl;
      }
      return null;
    },
    locale() {
      return this.$i18n.locale;
    },
    languageLocale() {
      return this.languages.filter((entry) => entry.language === this.locale);
    },
    languageNotLocale() {
      return this.languages.filter((entry) => entry.language !== this.locale);
    },
    title() {
      if (this.$route.meta.text) {
        return this.$route.meta.text;
      }
      //return this.$route.params.pathId;
      if (
        !this.$store.getters['paths/getPathById'](this.$route.params.pathId)
          .name
      ) {
        return '';
      }
      return this.$store.getters['paths/getPathById'](this.$route.params.pathId)
        .name.fr;
    },
    routeName() {
      return this.$route.name || null;
    },
    toolbarColor() {
      const pathId = this.$route.params.pathId
      const path = this.pathInformations(pathId) || {}
      if (path.colorPrimary) return path.colorPrimary
      else return "#009999"
    },
    pathMenuTitle() {
      if (this.$route.name && this.$route.name === 'pathManagement') {
        if (this.$route.params.pathId) {
          if (this.pathInformations(this.$route.params.pathId).name.fr) {
            // affiche le nom du parcours s'il y en a un
            return this.pathInformations(this.$route.params.pathId).name.fr;
          }
          return this.$t('toolBar.noNamePath');
        }
      }
      if (this.$route.name && this.$route.name === 'editMission') {
        if (this.$route.params.pathId) {
          if (this.pathInformations(this.$route.params.pathId).name.fr) {
            // affiche le nom du parcours s'il y en a un
            return this.pathInformations(this.$route.params.pathId).name.fr;
          }
          return this.$t('toolBar.noNamePath');
        }
      }
      if (this.$route.name && this.$route.name === 'newMission') {
        if (this.$route.params.pathId) {
          if (this.pathInformations(this.$route.params.pathId).name.fr) {
            // affiche le nom du parcours s'il y en a un
            return this.pathInformations(this.$route.params.pathId).name.fr;
          }
          return this.$t('toolBar.noNamePath');
        }
      }
      return null;
    },
    userPaths() {
      return this.$store.state.paths.paths;
    },
    pathMenu() {
      let pathMenu = [];
      Object.keys(this.userPaths).forEach((pathId) => {
        if (this.userPaths[pathId].name.fr) {
          pathMenu = [
            ...pathMenu,
            { pathId: pathId, pathName: this.userPaths[pathId].name.fr },
          ];
        }
      });
      return pathMenu;
    },
    isAdmin() {
      return this.currentUser && this.currentUser.isAdmin;
    },
    loginLabel() {
      let label = 'login as ';
      if (this.selected._id) {
        label = 'logged as ' + this.selected._id;
      }
      return label;
    },
    displayedUsers() {
      if (this.search) {
        const search = new JsSearch.Search('_id'); //);
        search.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
        search.addIndex('_id');
        search.addIndex(['content', 'profileIds']);
        search.addDocuments(this.users);
        return search.search(this.search);
      }
      return this.users;
    },
  },
  methods: {
    pathInformations(pathId) {
      return this.$store.getters['paths/getPathById'](pathId);
    },
    selectUserMenu(to) {
      if (to === 'disconnect') {
        this.logout();
      } else if (to === 'profile') {
        this.editUser();
      } else if (to === 'credits') {
        this.credits();
      }
    },
    isShowSavedModifications() {
      this.loadingSavedModifications = true;
      setTimeout(() => {
        this.loadingSavedModifications = false;
      }, 1300);
      setTimeout(() => {
        this.showSavedModifications = true;
      }, 1500);
      setTimeout(() => {
        this.showSavedModifications = false;
      }, 3000);
    },
    logout() {
      this.$store.dispatch('auth/LOG_OUT', this.$kuzzle).then(() => {
        this.$router.push('/login');
      });
    },
    async selectUser(id) {
      this.selected = this.users.find((u) => u._id === id);
      try {
        await this.logAs(this.selected);
        this.isLoggedAsOther = true;
        this.search = '';
      } catch (e) {
        console.log(e);
      }
    },
    // JCS à revoir
    async logAs(user) {
      try {
        this.$router.push('/homePage');
        console.log('user', user);
        user.content.kuid = user._id;
        const profile = user.content.profileIds.find((p) => p !== 'default');
        const index = 'site-' + profile.substring(0, profile.length - 5);
        const adminUsername = this.currentUser.username;
        this.$store.commit('auth/UNSET_CURRENT_USER');
        this.$store.commit('auth/SET_CURRENT_USER', {
          username: adminUsername,
          loggedAsUser: user.content.accountIds[0],
          content: user.content,
          index: 'clients',
          isAdmin: true,
        });
        const actions = [
          'paths/UNSUBSCRIBE',
          'paths/FETCH_PATHS',
          'paths/SUBSCRIBE',
          'missions/UNSUBSCRIBE',
          'missions/FETCH_MISSIONS',
          'missions/SUBSCRIBE',
          'accounts/UNSUBSCRIBE',
          'accounts/FETCH_ACCOUNT',
          'accounts/SUBSCRIBE',
          'stats/UNSUBSCRIBE',
          'stats/FETCH_STATS',
          'stats/SUBSCRIBE',
        ];
        await this.asyncForEach(actions, async (action) => {
          if (!action.includes('UNSUBSCRIBE')) {
            await this.$store.dispatch(
              action,
              { kuzzle: this.$kuzzle, index: 'clients' },
              { root: true }
            );
          } else {
            await this.$store.dispatch(action, this.$kuzzle, { root: true });
          }
        });
        this.$toast.show(`Vous etes loggué en tant que ${this.selected._id}`);
      } catch (e) {
        console.log('logAs failed', e);
      }
    },
    selectedPath(pathId) {
      localStorage.setItem('pathLang', 'fr');
      this.$router.push(`/pathManagement/${pathId}`);
    },
    async editUser() {
      this.$router.push(this.links.editAccountInfo.to);
    },
    async credits() {
      this.$router.push(this.links.credits.to);
    },
    async newPath() {
      this.$router.push('/homePage');
    },
    personalizePath(pathToPersonalize) {
      this.links.editAccountInfo.to = pathToPersonalize.replace(
        pathToPersonalize.substr(
          pathToPersonalize.substr(1).indexOf(':accountId') + 1
        ),
        this.currentAccountId
      );
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    langIconChangeSize(localeSize, otherSize) {
      this.languageLocale.map((entry) => {
        entry.size = localeSize;
      });
      this.languageNotLocale.map((entry) => {
        entry.size = otherSize;
      });
    },
    changeLocale(entry) {
      if (this.locale === entry.language) {
        return;
      }
      this.$i18n.locale = entry.language;
      this.langIconChangeSize('medium', 'small');
      this.$router.push('/homePage');
    },
  },
  async mounted() {
    this.$router.options.routes
      .find((route) => route.path === '/')
      .children.reduce((links, childRoute) => {
        if (childRoute.meta && !childRoute.meta.notInToolBar) {
          links[childRoute.name] = {
            to: '/' + childRoute.path,
            icon: childRoute.meta.icon,
            text: childRoute.meta.text,
            title: childRoute.name,
          };
        }
        return links;
      }, this.links);

    // personnalisation
    if (this.links.editAccountInfo && this.links.editAccountInfo.to) {
      this.personalizePath(this.links.editAccountInfo.to);
    }
    if (this.isAdmin) {
      try {
        let users = [];
        let loop = 0;
        let counter = 0;

        while (loop === 0) {
          let results = await this.$kuzzle.security.searchUsers(
            {
              query: {
                bool: {
                  must_not: [
                    {
                      terms: {
                        profileIds: ['mobile-user', 'admin'],
                      },
                    },
                  ],
                },
              },
            },
            { from: counter, size: 50 }
          );

          counter += 50;
          users.push(...results.hits);
          if (results.hits.length === 0) {
            loop = 1;
          }
        }
        this.users = users;
      } catch (error) {
        console.error(error.message);
        this.errorMessage = error.message;
      }
    }
  },
};
</script>

<style scoped lang="sass">
#core-toolbar

.btn-flag
  margin-left: 0px
  margin-right: 0px

.fixedPosition
  position: fixed;
  z-index: 100;

.pointerClass
  cursor: pointer

.classicBox
  height: 62px
  width: 100%

.redBox
  background-color: red !important
  height: 62px
  width: 100%

.leftSide
  position: absolute
  left: 0%

.rightSide
  position: absolute
  right: 0%

.logoImage
  max-width: 140px
  min-width: 140px

.menuTextClass
  min-width: 350px;
  margin-top: 12px;
  margin-bottom: 12px;

.menuTitleClass
  max-width: 400px;
  overflow: hidden;

.supportLink
  padding-left: 0px;
  min-width: 120px;
  max-width: 320px;
  font-size: large;
  text-align: center;
  text-justify: center;
  line-height: 120%

.savedText
  color: #66BB6A
  width: 100px;
  margin-left: 0px;
  text-align: center;
  text-justify: center;

.errorText
  color: red
  width: 100px;
  margin-left: 0px;
  text-align: center;
  text-justify: center;
.savedClass
  position: absolute;
  right: 350px;
  top: 100%

.userText
  color: white
  max-width: 100px;
  min-width: 50px;
  padding-right: 0px;
  margin-right: 0px;
  font-size: small;
  text-align: left;
  text-justify: center;
  line-height: 120%
</style>
